<template>
  <div>
    <b-card
      bg-variant="light"
      no-body
      class="shadow-none overflow-hidden"
    >
      <template v-if="!dataItem.id">
        <div class="text-center d-flex align-items-center align-items-center image-container">
          <div class="w-100">
            <div>
              <FeatherIcon
                icon="CameraIcon"
                size="18"
              />
            </div>
            <div class="font-weight-light">
              Ürün Fotoğrafı Yükleyin
            </div>
          </div>
        </div>
        <b-card-footer>
          <b-button
            :disabled="dataItem.disabled"
            variant="primary"
            block
            @click="setModal('products')"
          >
            <FeatherIcon icon="UploadIcon" />
            Fotoğraf Yükle
          </b-button>
          <b-button
            variant="outline-primary"
            block
            :disabled="userData.packageLimits[7].limit < 1"
            @click="openStockModal"
          >
            <FeatherIcon icon="EyeIcon" />
            Galeri Kullan
          </b-button>
        </b-card-footer>
      </template>
      <template v-else>
        <div>
          <b-img
            :src="dataItem.thumb"
            fluid
          />
        </div>
        <b-card-footer>
          <b-button
            :disabled="dataItem.disabled"
            variant="danger"
            block
            @click="removeImage(dataItem.id)"
          >
            <FeatherIcon icon="TrashIcon" />
            Fotoğrafı Sil
          </b-button>
          <b-button
            variant="outline-primary"
            block
            disabled
          >
            <FeatherIcon icon="EyeIcon" />
            Galeri Kullan
          </b-button>
        </b-card-footer>
      </template>
    </b-card>
    <stocks-modal />
    <cropper-image
      v-if="cropperSettings.type"
      :modal-status="cropperSettings.modalStatus"
      :close-modal="closeModal"
      :file-name="cropperSettings.fileName"
      :folder="cropperSettings.folder"
      :ratio="cropperSettings.ratio"
      :width-size="cropperSettings.widthSize"
      component="products"
      :params="cropperSettings.type"
      :item-id="$route.params.id"
      :ordering="itemKey + 1"
      @uploadImage="setUploadImage"
    />
  </div>
</template>
<script>
import {
  BCard, BCardFooter, BButton, BImg,
} from 'bootstrap-vue'
import StocksModal from '@/views/Products/elements/GalleryCard/StocksModal.vue'
import CropperImage from '@/layouts/components/common/CropperImage.vue'

export default {
  name: 'ImageCard',
  components: {
    CropperImage,
    BCard,
    BCardFooter,
    BButton,
    BImg,
    StocksModal,
  },
  props: {
    itemKey: {
      type: Number,
      required: true,
    },
    dataItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        widthSize: null,
        type: null,
      },
    }
  },
  computed: {
    stocksModal() {
      return this.$store.getters['zennoStocks/stocksModal']
    },
    productGallery() {
      return this.$store.getters['productGallery/dataList']
    },
  },
  methods: {
    openStockModal() {
      this.stocksModal.status = true
    },
    setModal(type) {
      if (type === 'products') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: 'product-image.jpg',
          folder: 'products',
          ratio: 4 / 3,
          type: 'products',
        }
      }
    },
    closeModal() {
      this.cropperSettings = {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      }
    },
    setUploadImage(item) {
      if (this.cropperSettings.type === 'products') {
        this.productGallery[this.itemKey].id_zenno_stocks = null
        this.productGallery[this.itemKey].filename = item.base_url + item.filename
        this.productGallery[this.itemKey].thumb = item.base_url + item.thumb
        this.productGallery[this.itemKey].filename_webp = item.base_url + item.filename_webp
        this.productGallery[this.itemKey].thumb_webp = item.base_url + item.thumb_webp

        this.$store.commit('products/SET_LOADING', true)
        this.$store.dispatch('productGallery/getDataList', this.$route.params.id)
          .then(res => {
            if (res) {
              this.$store.commit('products/SET_LOADING', false)
            }
          })
      }
      this.cropperSettings.modalStatus = false
    },
    removeImage(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('productGallery/removeData', id)
            .then(response => {
              if (response) {
                this.$store.commit('products/SET_LOADING', true)
                this.$store.dispatch('productGallery/getDataList', this.$route.params.id)
                  .then(res => {
                    if (res) {
                      this.$store.commit('products/SET_LOADING', false)
                    }
                  })
                this.$swal({
                  icon: 'success',
                  title: this.$store.state.app.removeResultTitle,
                  text: this.$store.state.app.removeResultMessage,
                  confirmButtonText: this.$store.state.app.removeResultClose,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              }
            })
        }
      })
    },
  },
}
</script>
<style scoped>
.image-container{
  aspect-ratio: auto 4/3;
}
</style>
